var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll"}],on:{"vScroll":function($event){return _vm.loadMore($event, _vm.tracks.next, _vm.getTracks)}}},[_c('tracks-list',{attrs:{"tracks":_vm.tracks.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }